import cookie from 'js-cookie';

// UT 在 cookie 中对应的 key（从环境变量读取）
const COOKIE_UT_KEY = process.env.REACT_APP_COOKIE_UT_KEY;

/**
 * 获取 UT
 */
export function getUt() {
  console.log(cookie.get(COOKIE_UT_KEY),111)
  if (!COOKIE_UT_KEY) return null;
  return cookie.get(COOKIE_UT_KEY) || null;
}
